module.exports = __webpack_public_path__ + "media/src/components/SubscriptionPlans/img/discover-3d5e45ed4126deeca9513116abfee469.png";